import Config from './config'
// import Effects from '../effects/effects'
// import Phaser from 'phaser'
import Planet from '../planet/planet'
import Star from '../star/star'
import Ship from '../ship/ship'
// import Satellite from '../satellite/satellite'
import Artifact from '../artifact/artifact'
// import Towable from '../towable/towable'

const devArtifacts = () => new Promise((resolve, reject) => {
    Config.gameStats.resources = 1000
    Config.difficultyLevels.difficulty2.planetColonizeTime = 200
    Config.difficultyLevels.difficulty2.shipBuildTime = 200
    Config.difficultyLevels.difficulty2.userShipSpeed = 1

    // Config.difficultyLevels.difficulty2.planetMineResourceDelay = 4000

    // const ships = []
    // for (let i = 0; i < 3; i += 1) {
    //     new Ship({
    //         faction: Config.userFactionName,
    //         orbitingEntity: homePlanet,
    //         // x: 300,
    //         // y: 300,
    //     })
    //
    //     new Satellite({
    //         faction: Config.userFactionName,
    //         orbitingEntity: homePlanet,
    //     })
    // }

    new Star({
        // discovered: true,
        x: 100,
        y: 100,
    })

    const homePlanet  = new Planet({
        faction: Config.userFactionName,
        colonized: true,
        discovered: true,
        isHomePlanet: true,
        isMiningResources: true,
        x: 100,
        y: 300,
    })

    new Planet({
        faction: Config.userFactionName,
        colonized: true,
        // discovered: true,
        // isMiningResources: true,
        x: 100,
        y: 500,
    })

    new Planet({
        // faction: Config.enemyFactionName,
        faction: null,
        // colonized: true,
        discovered: true,
        // isMiningResources: true,
        x: 250,
        y: 500,
    })

    new Artifact({
        x: 250,
        y: 100,
    })

    new Artifact({
        x: 250,
        y: 200,
    })

    new Ship({
        faction: Config.userFactionName,
        x: 250,
        y: 300,
    })

    // new Ship({
    //     faction: Config.enemyFactionName,
    //     x: 250,
    //     y: 350,
    // })

    return resolve({planet: homePlanet})
})

export default devArtifacts
